import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Dossie } from '../models/dossie.model';
import { DossieRepository, DOSSIER_REPOSITORY } from '../repositories/dossie.repository';
import { DossieListParams } from '../models/dossie-list-params.model';
import { PaginatedResponse } from '../../../core/shared/models/pagination.model';
import { DataLoadOrigin } from '../../../core/shared/models/data-load-options.model';

@Injectable({
  providedIn: 'root'
})
export class ListarDossiesUseCase {
  constructor(
    @Inject(DOSSIER_REPOSITORY) private readonly repository: DossieRepository
  ) {}

  execute(params: DossieListParams, origin: DataLoadOrigin = 'user'): Observable<PaginatedResponse<Dossie>> {
    void origin;
    return this.repository.listarDossies(params);
  }
}
